import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import './servicenew1.css';
import logo from "./image/logo.jpeg"

export default function ServiceNew() {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const sidebarRef = useRef(null);

  const navItems = [
    { id: "home", title: "HOME", path: "/" },
    {
      id: "services",
      title: "SERVICES",
      dropdown: [
        { label: "Painter", path: "/painterservice" },
        { label: "Home Appliance", path: "/homeapplience" },
        { label: "Plumber", path: "/plumberservice" },
        { label: "Cleaner", path: "/cleanerservice" },
        // { label: "Shop", path: "/showproduct" },
        { label: "Photography", path: "/yaadeinfilms" },
        { label: "Portfolio", path: "/portfolio" },
      ],
    },
    { id: "development", title: "DEVELOPMENT", path: "/development" },
    { id: "about", title: "ABOUT", path: "/about" },
    { id: "admin", title: "ADMIN", path: "/contactlist" },
    { id: "contact", title: "CONTACT US", path: "/contact" },
  ];

  const toggleDropdown = (id) => {
    setActiveDropdown((prev) => (prev === id ? null : id));
  };

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        event.target.id !== "sidebar-toggle-btn"
      ) {
        setIsSidebarOpen(false);
        setActiveDropdown(null);  
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      {/* Mobile Toggle Button */}
      <button id="sidebar-toggle-btn" onClick={toggleSidebar}>
        {isSidebarOpen ? "☰ Close" : "☰ Menu"}
      </button>

      {/* Mobile Sidebar */}
      <div
        ref={sidebarRef}
        className={`sidebar ${isSidebarOpen ? "open" : ""}`}
      >
        
<div className="logo">
              <a href="/"><img src={logo} alt="One Stop Services Logo" className="img-fluid logo-img" style={{ maxWidth: '60px', height: 'auto' }}>
              </img></a> 
              <a href="/">
          <h4>OneStopService</h4>
        </a> 
            
              
            </div>
        {navItems.map((item) => (
          <div key={item.id}>
            {item.dropdown ? (
              <>
                <div
                  className={`link ${activeDropdown === item.id ? "active" : ""}`}
                  onClick={() => toggleDropdown(item.id)}
                >
                  {item.title} ▼
                </div>
                {activeDropdown === item.id && (
                  <div className="dropdown">
                    {item.dropdown.map((subItem, index) => (
                      <Link
                        key={index}
                        to={subItem.path}
                        className={`sublink ${
                          location.pathname === subItem.path ? "active-sub" : ""
                        }`}
                        onClick={() => {
                          setActiveDropdown(null);
                          setIsSidebarOpen(false);
                        }}
                      >
                        {subItem.label}
                      </Link>
                    ))}
                  </div>
    
                )}
              </>
            ) : (
              <Link
                to={item.path}
                className={`link ${
                  location.pathname === item.path ? "active" : ""
                }`}
                onClick={() => setIsSidebarOpen(false)}
              >
                {item.title}
              </Link>
            )}
          </div>
        ))}
      </div> 
              
                  {isSidebarOpen && (
    <div className="backdrop" onClick={() => setIsSidebarOpen(false)} />
  )}
      {/* Desktop Navbar */}
      <div className="desktop-navbar">
        {/* <Link to="/" className="logo">OneStopService</Link> */}
        <div className="nav-links">
          {navItems.map((item) => (
            <div key={item.id} className="nav-item">
              {item.dropdown ? (
                <div className="dropdown-wrapper">
                  <span className="link">{item.title} ▼</span>
                  <div className="desktop-dropdown">
                    {item.dropdown.map((subItem, index) => (
                      <Link
                        key={index}
                        to={subItem.path}
                        className={`dropdown-link ${
                          location.pathname === subItem.path ? "active-sub" : ""
                        }`}
                      >
                        {subItem.label}
                      </Link>
                    ))}
                  </div>
                </div>
              ) : (
                <Link
                  to={item.path}
                  className={`link ${
                    location.pathname === item.path ? "active" : ""
                  }`}
                >
                  {item.title}
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
